import script from "./TextArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextArea.vue?vue&type=script&lang=ts&setup=true"

import "./TextArea.vue?vue&type=style&index=0&id=65d72404&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d72404"]])

export default __exports__